// 실행 플랫폼 판별. Capacitor 네이티브 앱(안드로이드/iOS) 여부로 웹과 다른 흐름을 분기한다.
//  - 웹(PWA/브라우저)에서는 항상 false 라 기존 동작이 그대로 유지된다.
//  - 소셜 로그인/결제 등 "외부로 나갔다 앱으로 복귀"가 필요한 흐름에서 딥링크 처리 여부를 가른다.

import { Capacitor } from "@capacitor/core";

// 네이티브 앱(WebView 래핑)에서 실행 중인가.
export const isNativeApp = Capacitor.isNativePlatform();

// 소셜 로그인 딥링크 복귀 스킴/경로. 서버 OAuth 콜백이 native 요청에는 이 URL 로 302 한다.
//  - AndroidManifest 의 intent-filter(scheme=openchuksan)와 반드시 일치해야 한다.
export const NATIVE_DEEP_LINK_SCHEME = "openchuksan";
export const SOCIAL_CALLBACK_PATH = "/auth/social-callback";
